import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class DeferredIncomeTax extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '递延所得税情况';
    }

    getColumns = () => {
        return [{
            title: '',
            dataIndex: 'year'
        }, {
            title: '递延所得税',
            dataIndex: 'deferTax'
        }, {
            title: '所有者权益',
            dataIndex: 'ownerEquity'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/DeferredIncomeTax.jsx